import React, { useState, useContext, memo } from "react";

import ArrowRightOutlined from "@material-ui/icons/ArrowRightOutlined";

import { Link, useHistory } from "react-router-dom";

import { SidebarContext } from "../../context/SidebarContext";
import "./sidebar.css";

const SubMenu = ({ item }) => {
  const history = useHistory();
  const [subnav, setSubnav] = useState(false);
  const { handleChangeOpenSidebar } = useContext(SidebarContext);

  const handleClickMenu = (value) => {
    if (value) return setSubnav(!subnav);

    handleChangeOpenSidebar(false);
  };

  return (
    <>
      <Link
        className={
          !subnav &&
          history.location.pathname.indexOf(item.context || item.path) !== -1
            ? "link-container-select"
            : "link-container"
        }
        to={item.path || history.location.pathname}
        onClick={() => handleClickMenu(item.subNav)}
      >
        <div>
          {item.icon}
          <label
            className="link-title"
            to={item.path || history.location.pathname}
          >
            {item.title}
          </label>
        </div>
        <div>
          {item.subNav && subnav
            ? item.iconOpened
            : item.subNav
            ? item.iconClosed
            : null}
        </div>
      </Link>
      {subnav &&
        item.subNav.map((item, index) => {
          return (
            <Link
              className={
                history.location.pathname.indexOf(item.path) !== -1
                  ? "link-container-subitem-select"
                  : "link-container-subitem"
              }
              to={item.path || history.location.pathname}
              key={index}
              onClick={() => handleChangeOpenSidebar(false)}
            >
              {item.icon || (
                <ArrowRightOutlined style={{ fontSize: 15, marginTop: -7 }} />
              )}
              <label
                className="link-title"
                to={item.path || history.location.pathname}
              >
                {item.title}
              </label>
            </Link>
          );
        })}
    </>
  );
};

export default memo(SubMenu);
